export const REQUEST_DOCUMENT_STORAGES = 'REQUEST_DOCUMENT_STORAGES';
export const RECEIVE_DOCUMENT_STORAGES= 'RECEIVE_DOCUMENT_STORAGES';

export const REQUEST_CONFIGURATOR_DATA = 'REQUEST_CONFIGURATOR_DATA';
export const REFRESH_CONFIGURATOR_DATA = 'REFRESH_CONFIGURATOR_DATA';
export const RECEIVE_CONFIGURATOR_DATA = 'RECEIVE_CONFIGURATOR_DATA';

export const REQUEST_CAMPAIGNS = 'REQUEST_CAMPAIGNS';
export const RECEIVE_CAMPAIGNS = 'RECEIVE_CAMPAIGNS';

export const REQUEST_DOCUMENT_STORAGE = 'REQUEST_DOCUMENT_STORAGE';
export const REQUEST_DOCUMENT_STORAGE_SUCCESS = 'REQUEST_DOCUMENT_STORAGE_SUCCESS';

export const DELETE_DOCUMENT_STORAGE = 'DELETE_DOCUMENT_STORAGE';
export const DELETE_DOCUMENT_STORAGE_SUCCESS = 'DELETE_DOCUMENT_STORAGE_SUCCESS';

export const LOGIN_REQUIRED = 'LOGIN_REQUIRED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_MODAL_OPEN = 'LOGIN_MODAL_OPEN';
export const LOGIN_MODAL_CLOSE = 'LOGIN_MODAL_CLOSE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';
export const USER_STATUS_SUCCESS = 'USER_STATUS_SUCCESS';

export const REQUEST_START = 'REQUEST_START';
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS';

export const APP_SET_LOCALE_CONTEXT = 'APP_SET_LOCALE_CONTEXT';
export const REQUEST_APP_CONFIG = 'REQUEST_APP_CONFIG';
export const RECEIVE_APP_CONFIG = 'RECEIVE_APP_CONFIG';

export const REQUEST_CART = 'REQUEST_CART';
export const RECEIVE_CART = 'RECEIVE_CART';
export const UPDATE_CART_ITEM = 'UPDATE_CART_QUANTITY';
export const REQUEST_APPROVAL = 'REQUEST_APPROVAL';
export const RECEIVE_APPROVAL_SUCCESS = 'RECEIVE_APPROVAL_SUCCESS';
export const RECEIVE_APPROVAL_SUCCESS_HIDE = 'RECEIVE_APPROVAL_SUCCESS_HIDE';
export const REQUEST_PROCESS_CART = 'REQUEST_PROCESS_CART';
export const RECEIVE_PROCESS_CART = 'RECEIVE_PROCESS_CART';
export const END_PROCESS_CART = 'END_PROCESS_CART';

export const REQUEST_IMAGE_UPLOAD = 'REQUEST_IMAGE_UPLOAD';
export const REQUEST_IMAGE_UPLOAD_ERROR = 'REQUEST_IMAGE_UPLOAD_ERROR';
export const RECEIVE_IMAGE_UPLOAD = 'RECEIVE_IMAGE_UPLOAD';
export const ADD_IMAGE_UPLOAD = 'ADD_IMAGE_UPLOAD';
export const DELETE_IMAGE_UPLOAD = 'DELETE_IMAGE_UPLOAD';
export const DELETE_IMAGE_UPLOAD_SUCCESS = 'DELETE_IMAGE_UPLOAD_SUCCESS';
export const DELETE_IMAGE_UPLOAD_ERROR = 'DELETE_IMAGE_UPLOAD_ERROR';
export const LOADING_WIDGET_SUCCESS = 'LOADING_WIDGET_SUCCESS';

export const REQUEST_ORGANISATION_USERS = 'REQUEST_ORGANISATION_USERS';
export const RECEIVE_ORGANISATION_USERS = 'RECEIVE_ORGANISATION_USERS';


// WEBPACK FOOTER //
// ./src/js/constants/ActionType.js